import React, { FC } from 'react';
import styled from 'styled-components';

import { THEME_BLACK, THEME_PRIMARY, THEME_SILVER, themeColor } from '../../styles/basics/colors';
import SubNavigationLayout from '../../shared/navigation/SubNavigationLayout';
import { Switch, useParams, useRouteMatch } from 'react-router';
import { Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const StUlNav = styled.ul`
    display: inline-flex;
    font-size: 16px;
    line-height: 22px;
`;

const StbackButton = styled.a`
    margin-right: 10px;
    color: ${themeColor(THEME_BLACK)};

    &.active {
        color: ${themeColor(THEME_PRIMARY)};
    }

    &.back {
        color: ${themeColor(THEME_PRIMARY)};
    }

    &:hover {
        color: ${themeColor(THEME_SILVER)};
    }
`;

type Props = {
    readonly isSticky: boolean;
};

const OrdersNavigation: FC<Props> = ({ isSticky }) => {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/:orderId?`}>
                <OrdersNavigationBreadcrumbs isSticky={isSticky} />
            </Route>
        </Switch>
    );
};

export default OrdersNavigation;

type OrdersNavigationBreadcrumbsProps = {
    readonly isSticky: boolean;
};

const OrdersNavigationBreadcrumbs: FC<OrdersNavigationBreadcrumbsProps> = ({ isSticky }) => {
    const { t } = useTranslation();
    const { orderId } = useParams<{ orderId?: string }>();

    const breadcrumbs = (
        <StUlNav>
            {!isSticky ? (
                <li>
                    <StbackButton onClick={() => window.history.back()} className="back fl-left">
                        <i className="material-icons bigger">arrow_back</i>
                    </StbackButton>
                </li>
            ) : null}
            <li>
                <span>{t('shop.orders.ordersTitle')}</span>
            </li>
            {orderId ? (
                <li>
                    <span>
                        <i className="material-icons big">keyboard_arrow_right</i>
                    </span>
                    <span>
                        {t('shop.orders.orderDetailTitle', {
                            orderId
                        })}
                    </span>
                </li>
            ) : null}
        </StUlNav>
    );

    return <SubNavigationLayout left={breadcrumbs} isSticky={isSticky} width="50" />;
};
